import { MeshStandardMaterial, Shader, SkinnedMesh } from 'three';

export class Uniform<UniformType> {
  value: UniformType;
  constructor(value_: UniformType) {
    this.value = value_;
  }
}
